import { Component, Input, OnInit } from "@angular/core";
import { ClassificationClass } from "../Model/classification/ClassificationClass";
import { ClassificationSystem } from "../Model/classification/ClassificationSystem";
import { ClassificationService } from "../Services/classification.service";
import { LoginService } from "../Services/login.service";
import { AddonService } from "../Services/addon.service";
import { lastValueFrom } from "rxjs";
import { SystemService } from "../Services/system.service";
import { TranslateService } from "@ngx-translate/core";
import { ClassificationFeature } from "../Model/classification/ClassificationFeature";
import { FeatureValue } from "../Model/classification/FeatureValue";

@Component({
    selector: "classificationGroup",
    templateUrl: "classificationGroup.component.html",
    standalone: false
})
export class ClassificationGroupComponent implements OnInit {
  @Input() selectedClassificationSystem: ClassificationSystem;
  @Input() selectedClassificationClass: ClassificationClass;
  @Input() classificationClasses: ClassificationClass[] = [];

  addonList: string[] = [];
  valueTypeSource = [ "List", "Number", "String" ];

  constructor(public classificationService: ClassificationService, public loginService: LoginService,
    private addonService: AddonService, private systemService: SystemService, public translate: TranslateService) {

  }

  async ngOnInit() {
    this.addonList = await lastValueFrom(this.addonService.getAllClassificationAddons());
  }

  async updateClassificationSystem() {
    await this.classificationService.updateClassificationSystem(this.selectedClassificationSystem);
  }

  async updateClassificationClass(event?, feature?: any) {
    if (event && !event.event) {
      return;
    }

    if (!this.selectedClassificationClass.number || !this.selectedClassificationClass.name) {
      this.systemService.notifyWarning(this.translate.instant("Die Klasse wurde nicht gespeichert, der Name und die Nummer muss vergeben werden!"));
      return;
    }

    var classesWithSameNumber = this.classificationClasses.find(x => x.number == this.selectedClassificationClass.number &&
                                                                     x.id != this.selectedClassificationClass.id);
    if (classesWithSameNumber) {
      this.systemService.notifyWarning(this.translate.instant("Die Klasse kann unter der Nummer {{classNumber}} nicht gespeichert, da diese Nummer schon vergeben ist!", { classNumber: this.selectedClassificationClass.number }));
      this.selectedClassificationClass.number = event.previousValue;
      return;
    }

    await this.classificationService.updateClassificationClass(this.selectedClassificationClass);
    this.selectedClassificationClass.features
      .sort((a, b) => a.order - b.order);

    if (feature && feature.order) {
      this.selectedClassificationClass.features.find(x => x.order == feature.order).values.sort((a, b) => a.order - b.order);
    }
  }

  async addNewFeatureToClassificationClass() {
    var newFeature = new ClassificationFeature();
    var orders = this.selectedClassificationClass.features.map(x => x.order);
    newFeature.order = this.findUniqueOrder(orders);
    this.selectedClassificationClass.features.push(newFeature);
    this.updateClassificationClass();
  }

  async addNewFeatureValueToFeature(feature: ClassificationFeature) {
    var newFeatureValue = new FeatureValue();
    if (!feature.values) {
      feature.values = [];
    }
    var orders = feature.values.map(x => x.order);
    newFeatureValue.order = this.findUniqueOrder(orders);
    feature.values.push(newFeatureValue);
    this.updateClassificationClass();
  }

  findUniqueOrder(orders: number[]): number {
    let order = 1;
    while (orders.includes(order)) {
      order++;
    }
    return order;
  }
}
